import * as types from '../mutation-types'

import Vapi from 'vuex-rest-api'
import { defaults, merge } from 'lodash'
import Vue from 'vue'

const module = new Vapi({
  baseURL: Vue.$backendBaseURL,
  state: {
    all: [],
    current: {}
  }
})
.get({
  action: 'listOrgs',
  property: 'all',
  path: '/orgs',
  queryParams: true
})
.get({
  action: 'getOrg',
  property: 'current',
  path: ({ id }) => `/orgs/${id}`
})
.post({
  action: 'createOrg',
  property: 'current',
  path: '/orgs'
})
.put({
  action: 'updateOrg',
  property: 'current',
  path: ({ id }) => `/orgs/${id}`
})
.get({
  action: 'cps',
  property: 'current',
  path: ({ id }) => `/orgs/${id}/cps`
})
.put({
  action: 'cps',
  property: 'current',
  path: ({ id }) => `/orgs/${id}/cps`
})
.getStore()

const state = {
}

const getters = {
  getOrgById (state) {
    return function (id) {
      return defaults(state.all.find(item => item.id === id),
        {
          prefix: null,
          maxAttempts: null,
          maxChannels: null
        }
      )
    }
  }
}

const actions = {
  reset ({ commit, rootState }) {
    commit(types.RESET_ORG_STATE)
  }
}

const mutations = {
  [types.RESET_ORG_STATE] (state) {
    state.all = []
    state.current = {}
    state.pending = {
      all: false,
      current: false
    }
    state.error = {
      all: null,
      current: null
    }
  },
  [types.RESET_ORG_CURRENT] (state) {
    state.current = {}
    state.pending.current = false
    state.error.current = null
  }
}

export default merge(module, {
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/modules/organization.js